module.exports = __webpack_public_path__ + "img/icon_hongbao@2x.eca1ab9f.png";